<template>
    <v-card style="height:100%">
      <v-card-title>
        <v-row no-gutters v-if="table_only === undefined || table_only === false">
          <v-row style="height: fit-content;" class="align-center d-flex flex-row" no-gutters> <v-col :lg="3">
              <v-text-field v-model="search" append-icon="search" label="Search" placeholder="Search" hide-details outlined
                dense></v-text-field>
            </v-col>
  
            <div style="padding: 12px;"><v-btn color="green" elevation="0" text depressed><v-icon color="#808080">{{
              "mdi-filter-variant" }}</v-icon></v-btn></div>
  
            <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text depressed color="green" readonly v-bind="attrs" v-on="on">
                  <div style="color: #808080;">New View </div>
                  <div style="color: #808080;"> - </div>
                  <div style="color: #4A4A4A;"> TO TODAY</div>
                </v-btn>
              </template>
              <v-date-picker no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary">Cancel</v-btn>
                <v-btn text color="primary">OK</v-btn>
              </v-date-picker>
            </v-menu>
  
            <v-btn text color="transparent">
              <div style="color: #808080;">DISPLAYING </div>
              <div style="color: #4A4A4A;"> 15 / 15 </div>
              <div style="color: #808080;"> · TOTAL</div>
            </v-btn>
  
          </v-row>
          <v-col class="d-flex flex-row-reverse align-center">
            <v-btn v-if="(hideAddButton === undefined || hideAddButton == false)" depressed dark color="green"
              @click="addItem()">
              <v-icon color="white" dark>mdi-plus</v-icon>
            </v-btn>
            <!-- <v-btn text depressed color="green" class="mr-2" :disabled="loading" @click="getItems()">
              <v-icon left dark>mdi-refresh</v-icon>
              {{ reloadText }} 
            </v-btn> -->
            <v-btn text depressed color="green" class="mr-2" @click="ClearAllClicked()" :disabled="clearClicked"
              v-if="(show_clear !== undefined && show_clear === true && items.length > 0)">
              Clear All
            </v-btn>
            <v-btn text depressed color="green" class="" @click="GeneratePDFFile()" :disabled="printClicked"
              v-if="(show_print !== undefined && show_print === true)">
              <v-icon color="black" dark>mdi-file-outline</v-icon>
            </v-btn>
            <v-btn text depressed color="green" class="" @click="GenerateExcelFile()" :disabled="excelClicked"
              v-if="(show_excel !== undefined && show_excel === true)">
              <v-icon color="black" dark>mdi-file-excel-outline</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="6">
            <span>{{ title }}</span>
          </v-col>
          <v-col class="d-flex flex-row-reverse"
            v-if="(show_clear !== undefined && show_clear === true && items.length > 0)">
            <v-btn :disabled="clearClicked" rounded color="primary" @click="ClearAllClicked()">Clear All</v-btn>
          </v-col>
          <v-col class="d-flex flex-row-reverse" v-if="(show_excel !== undefined && show_excel === true)">
            <v-btn :disabled="excelClicked" rounded color="primary" @click="GenerateExcelFile()">Excel</v-btn>
          </v-col>
          <v-col class="d-flex flex-row-reverse" v-if="(show_print !== undefined && show_print === true)">
            <v-btn :disabled="printClicked" rounded color="primary" @click="GeneratePDFFile()">Print</v-btn>
          </v-col>
          <v-col class="d-flex flex-row-reverse">
            <v-btn rounded color="primary" @click="ViewAllClicked()">View All</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
  
      <v-select @change="onChange()" outlined style="width: 20%;
      display: inline-block;
      padding: 16px;" v-if="this.user.roleId == 1 && (entity_name == 'wayBill' ||
        entity_name == 'pending_wayBill')" v-model="selectedFFId" :items="freightForwarders" label="Freight Forwarder"
        item-text="userFullName" item-value="id"></v-select>
  
      <v-select @change="onChange()" outlined style="width: 20%; 
      display: inline-block; " v-if="entity_name == 'wayBill' ||
        entity_name == 'pending_wayBill'" v-model="selectedWBStatusId" :items="waybillStatuses" label="Waybill Status"
        item-text="StatusName" item-value="StatusId"></v-select>

  
      <v-container class="pt-6 pb-6">
  
        <div class="grid-row" style="--bs-columns: 3;" no-gutters>
  
          <v-card class="g-col-2 g-col-md-2"  v-for="(item, i) in items" v-bind:data="item"
            v-bind:key="item.id" @click="rowClick(item)">
            <div v-if="item.waybillStatus !== undefined">
              <div v-if="item.waybillStatus == 'Active'" class="card-top-gradient-yellow h-25 w-100"></div>
              <div v-if="item.waybillStatus == 'In Progress'" class="card-top-gradient-yellow h-25 w-100"></div>
              <div v-if="item.waybillStatus == 'Completed'" class="card-top-gradient-green h-25 w-100"></div>
              <div v-if="item.waybillStatus == 'Pending FF'" class="card-top-gradient-red h-25 w-100"></div>
              <div v-if="item.waybillStatus == 'TEST'" class="card-top-gradient-blue h-25 w-100"></div>
              <div v-if="item.waybillStatus == undefined" class="card-top-gradient-blue h-25 w-100"></div>
              <div v-if="item.waybillStatus == 'Pending Admin'" class="card-top-gradient-red h-25 w-100"></div>
              <div v-if="item.waybillStatus == 'Rejected'" class="card-top-gradient-red h-25 w-100"></div>
            </div>
  
            <v-row style="gap: 6px;" class="no-gutters justify-space-between flex-nowrap pa-3">
  
              <v-col class="waybill-card-grid flex-nowrap ">
  
  
                <template
                  v-for="(field, j) in headers.filter(h => h.hide_in_table === undefined && (user.roleId === 1 || h.hide_client === undefined))">
                  <div
                    v-if="field.value != 'user' && field.value != 'action' && field.value != 'freightForwarder' && field.value != 'packages' && field.value != 'drivers' && field.value != 'driver' && field.value != 'trucks' && field.value != 'deliveryAddresses' && field.value != 'qrCode' && field.value != 'profileImage' && field.value != 'idGender' && field.value != 'idBloodType'">
                    <div class="font-weight-medium text-caption text-uppercase mt-1">{{ field.text }}</div>
                    <div class="font-weight-regular text-subtitle-2 mt-1">
                      {{ item[field.value] }}
                    </div>
                  </div>
                </template>
                <template>
                <div v-if="item.user !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">user</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.user.email }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.freightForwarder !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">freight forwarder</div>
                  <div class="font-weight-regular text-subtitle-2 mt-1">{{ item.freightForwarder.userFullName }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.packages != undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">packages</div>
                  <div v-for="(pack, index) in item.packages" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ pack.identifier }}</div>
                </div>
              </template>
              <template>
                <div v-if="item.drivers !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">drivers</div>
                  <div v-for="(driver, index) in item.drivers" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ driver.email }}</div>
                </div>
              </template>
              <template>
                <div  v-if="item.trucks !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">trucks</div>
                <div 
                style="display: flex; flex-direction: row; flex-wrap: nowrap; max-width: 100px;"
                >  <marquee 
                   behavior="scroll" direction="left">
                  <div style="display: flex; flex-direction: row; flex-wrap: nowrap;"><p v-for="(truck, index) in item.trucks" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2">{{ truck.truckIdentifier + " - "}}</p></div></marquee></div>
                </div>
              </template>
              <template>
                <div v-if="item.deliveryAddresses !== undefined">
                  <div class="font-weight-medium text-caption text-uppercase mt-1">delivery stations</div>
                  <div v-for="(deliveryAddress, index) in item.deliveryAddresses" :key="`pkg_${index}`"
                    class="font-weight-regular text-subtitle-2 mt-1">{{ deliveryAddress.name }}</div>
                </div>
              </template>
              </v-col>
              <!-- <v-row style="height: 24px;" class="justify-end no-gutters">
                <v-icon color="red" medium @click="deleteItem(item)">
                  mdi-delete-outline
                </v-icon>
                <v-chip v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" small class="mr-2"
                  @click="approveItem(item)">
                  Approve
                </v-chip>
                <v-chip v-if="item.waybillStatus == 'Pending FF' && user.roleId == 5" small @click="rejectItem(item)">
                  Reject
                </v-chip>
              </v-row> -->
  
  
  
            </v-row>
            <!-- <v-card-actions>
        <v-btn variant="text" color="deep-purple-accent-4"> Learn More </v-btn>
  
      </v-card-actions> -->
          </v-card>
  
        </div>
  
  
      </v-container>
  
  
    </v-card>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  import MediaMixin from '../mixins/media';
  import StaticMixin from '../mixins/static';
  
  export default {
    data() {
      return {
        excelClicked: false,
        printClicked: false,
        clearClicked: false,
        search: '',
        reloadText: 'Reload',
        reload: false,
        delete_click: false,
        page: 1,
        perPage: 10,
        search: "",
        selectedFFId: 0,
        selectedWBStatusId: 0,
        freightForwarders: [],
        waybillStatuses: []
      }
    },
    props: ['items', 'headers', 'hideAddButton', 'allowEdit', 'entity_name', 'user_id', 'driver_id', 'localizable_fields', 'no_actions', 'paginated', 'table_only', 'title', 'show_clear', 'show_excel', 'show_print'], //the data to retrieve might belong to a user or driver
    computed: {
      ...mapState('entities', ['current_entity', 'entities', 'loading', 'pageCount']),
      ...mapState('users', ['user']),
      allHeaders() {
        return this.localizable_fields !== undefined ? this.localizable_fields.concat(this.headers) : this.headers;
      }
    },
    mixins: [MediaMixin, StaticMixin],
    methods: {
      ...mapActions('entities', ['getEntities', 'saveEntity', 'deleteEntity', 'getPaginatedEntities', 'clearAllEntities', 'approvalResponse']),
      rowClick(row) {
        if (this.allowEdit === undefined || this.allowEdit == true) {
          localStorage.setItem("SelectedwaybillStatus", "");
          localStorage.setItem("UserRoleId", this.user.roleId);
          if (!this.delete_click) this.$emit('rowClick', row)
          if (row.waybillStatus != null) {
            localStorage.setItem("SelectedwaybillStatus", row.waybillStatus);
          }
        }
      },
      onChange() {
        localStorage.setItem('selectedFFId', this.selectedFFId);
        localStorage.setItem('selectedWBStatusId', this.selectedWBStatusId);
  
        this.getEntities(this.entity_name);
      },
      reloadFreightForwarders() {
        this.waybillStatuses = [];
  
        this.waybillStatuses.push({
          StatusId: 0,
          StatusName: "All"
        });
  
        this.waybillStatuses.push({
          StatusId: 1,
          StatusName: "Active"
        });
  
        this.waybillStatuses.push({
          StatusId: 2,
          StatusName: "Completed"
        });
  
        this.waybillStatuses.push({
          StatusId: 3,
          StatusName: "Pending FF"
        });
  
        this.waybillStatuses.push({
          StatusId: 4,
          StatusName: "Pending Admin"
        });
  
        this.waybillStatuses.push({
          StatusId: 5,
          StatusName: "In Progress"
        });
        //load the trucks available to be assigned for this driver
        //var url = `/trucks/availableTrucks`
        var url = `user/getlistFF`
        axios({
          method: "GET",
          url: `${process.env.VUE_APP_baseURL}${url}`,
        }).then(response => {
          let dataobj = {
            userFullName: "All",
            id: 0
          };
          this.freightForwarder = [];
          this.freightForwarders.push(dataobj);
          this.freightForwarders.push.apply(this.freightForwarders, response.data.data)
        }).catch(error => {
          console.log(`ERRORRRRRRRRR ${error}`)
        })
      },
      getFieldName(field) {
        return 'item.' + field.value;
      },
      editItem(item) {
        console.log("editing " + item);
      },
      getItems() {
        console.log(`paginatedkhan:${this.paginated}`)
        if (this.paginated === undefined || this.paginated === false) {
          if (this.selectedFFId != null) {
            this.getEntities(this.entity_name, this.selectedFFId);
          } else {
            this.getEntities(this.entity_name);//this.selectedFFId)
          }
        }
        else {
          var paginatedPayload = {
            name: this.entity_name,
            page: this.page,
            perPage: this.perPage,
            search: this.search
          }
          this.getPaginatedEntities(paginatedPayload)
        }
      },
      deleteItem(item) {
        this.delete_click = true;
        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          this.delete_click = false;
          if (result.value) {
            item.entity_name = this.entity_name;
            this.deleteEntity(item, response => {
              this.getItems();
            })
          }
        })
      },
      approveItem(item) {
        this.delete_click = true;
        item.entity_name = this.entity_name;
        item.entity_status = 'Active';
        this.approvalResponse(item, response => {
          this.delete_click = false;
          this.getItems();
        });
      },
      rejectItem(item) {
        this.delete_click = true;
        item.entity_name = this.entity_name;
        item.entity_status = 'Rejected';
        this.approvalResponse(item, response => {
          this.delete_click = false;
          this.getItems();
        });
      },
      addItem() {
        this.current_entity[this.entity_name] = {};
        this.$emit('add');
      },
      headerContains(title) {
        for (var i = 0; i < this.headers.length; ++i) {
          var h = this.headers[i];
          if (h.value === title) return true;
        }
        return false
      },
      getGenericHeaders() {
        //return the generic headers that don't need custom rendering
      },
      getQrCodeMediaUrl(item) {
        if (item.qrCodeMedia !== undefined)
          return item.qrCodeMedia.url;
        return '';
      },
      ViewAllClicked() {
        var page = "";
        if (this.entity_name == 'notification') {
          page = "NotificationsDetailed";
        } else {
          page = this.entity_name + "s";
        }
        this.$router.push(page);
      },
      ClearAllClicked() {
        this.clearClicked = true;
        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, clear all!'
        }).then((result) => {
          this.delete_click = false;
          if (result.value) {
            this.items = [];
            var name = this.entity_name;
            if (name.includes("pending_")) {
              var name_arr = name.split('_');
              var name = name_arr[1];
            }
            var url = name + `/clearAll`;
            axios({
              method: "POST",
              url: `${process.env.VUE_APP_baseURL}${url}`,
            }).then(response => {
              this.clearClicked = false;
            }).catch(error => {
              console.log(`ERRORRRRRRRRR ${error}`);
              this.clearClicked = false;
            });
            this.pageCount[this.entity_name] = 0;
          }
        })
      },
      GenerateExcelFile() {
        this.excelClicked = true;
        const mimeType = 'data:application/vnd.ms-excel';
        const tbl = document.getElementById('table');
        const wrapper = tbl.querySelector('.v-data-table__wrapper');
        const clonedTable = wrapper.cloneNode(true);
        const documentPrefix = (this.title != undefined && this.title != '') ? this.title.replace(/ /g, '-') : this.entity_name;
        const d = new Date();
        const dummy = document.createElement('a');
        dummy.href = mimeType + ', ' + encodeURI(clonedTable.outerHTML);
        dummy.download = documentPrefix
          + '-' + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
          + '-' + d.getHours() + '-' + d.getMinutes() + '-' + d.getSeconds()
          + '.xls';
        document.body.appendChild(dummy);
        dummy.click();
        document.body.removeChild(dummy);
        this.excelClicked = false;
      },
      GeneratePDFFile() {
        this.printClicked = true;
        const tbl = document.getElementById('table');
        const wrapper = tbl.querySelector('.v-data-table__wrapper');
        var tds = wrapper.getElementsByTagName('td');
        var previousPadding = null;
        for (let t = 0; t < tds.length; t++) {
          const cell = tds[t];
          if (cell.className != 'text-start') {
            continue;
          }
          cell.setAttribute('style', 'padding:0px !important');
        }
        const clonedTable = wrapper.cloneNode(true);
        this.synchronizeCssStyles(wrapper, clonedTable, true);
        clonedTable.setAttribute('style', 'overflow-x:visible;background-color:white;z-index:100000');
        clonedTable.style.position = 'absolute !important';
        clonedTable.style.width = window.outerWidth + 'px';
        clonedTable.style.height = '100%';
        clonedTable.style.boxShadow = '0px 0px 0px 1px rgba(0,0,0,0.2)';
        clonedTable.style.margin = '0px auto';
        clonedTable.style.top = 0;
        clonedTable.style.bottom = 0;
        clonedTable.style.left = 0;
        clonedTable.style.right = 0;
        clonedTable.id = 'clonedTable';
        document.body.insertBefore(clonedTable, document.body.firstChild);
  
        for (let v = 0; v < tds.length; v++) {
          const cell = tds[v];
          if (cell.className != 'text-start') {
            continue;
          }
          cell.setAttribute('style', 'padding:0px 16px');
        }
  
        let win = window.open('', '');
        win.document.body.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif';
        win.document.body.innerHTML = clonedTable.innerHTML;
        win.print();
        win.close();
        document.getElementById('clonedTable').remove();
        this.printClicked = false;
      },
      synchronizeCssStyles(src, destination, recursively) {
        destination.style.cssText = this.getComputedStyleCssText(src);
        if (recursively) {
          const vSrcElements = src.getElementsByTagName('*');
          const vDstElements = destination.getElementsByTagName('*');
          for (var i = vSrcElements.length; i--;) {
            const vSrcElement = vSrcElements[i];
            const vDstElement = vDstElements[i];
            vDstElement.style.cssText = this.getComputedStyleCssText(vSrcElement);
          }
        }
      },
      getComputedStyleCssText(element) {
        const cssObject = window.getComputedStyle(element);
        const cssAccumulator = [];
        if (cssObject.cssText !== '') {
          return cssObject.cssText;
        }
        for (let prop in cssObject) {
          if (typeof cssObject[prop] === 'string') {
            cssAccumulator.push(prop + ' : ' + cssObject[prop]);
          }
        }
        return cssAccumulator.join('; ');
      }
    },
    mounted() {
      this.reload = true
      var isNotificationPage = false;
      if (this.items != null && this.items.length > 0 && this.items[0].isSignalR != undefined) {
        isNotificationPage = true;
      }
      if (!this.headerContains('action') && this.no_actions === undefined && isNotificationPage != true) {
        this.headers.push({ text: 'Actions', value: 'action', sortable: false })
      }
      //also check if should remove some field
      //start from end to beginning to keep the indexes correct
  
      setTimeout(h => { this.reload = false }, 50);
      this.reloadFreightForwarders();
    },
    watch: {
      loading(newValue) {
        this.reloadText = newValue ? 'Reloading...' : 'Reload'
      },
      page(newValue) {
        this.getItems()
      },
      perPage(newValue) {
        this.getItems()
      }
    }
  }
  </script>
  <style lang="css" scoped>span.v-chip.theme--dark.v-size--default {
    margin: 2px;
  }</style>